<script setup lang="ts">
// 選択範囲を調整: 滑らかに / ぼかし / コントラスト / エッジをシフト。
// ダイアログ中はクイックマスク表示で結果をプレビューし、OK で確定 (1 履歴)。
import { onBeforeUnmount, ref, watch } from 'vue'
import { useDocumentStore } from '@/stores/documentStore'
import { useUiStore } from '@/stores/uiStore'
import { useModal } from '@/composables/useModalStack'
import { useI18n } from '@/i18n'
import { runCommand } from '@/commands/registry'
import { refineMask } from '@/selection/modify'
import SliderField from '@/components/common/SliderField.vue'

const emit = defineEmits<{ close: [] }>()
useModal('refine-edge')
const { t } = useI18n()
const docStore = useDocumentStore()
const ui = useUiStore()
const smooth = ref(0)
const feather = ref(0)
const contrast = ref(0)
const shift = ref(0)
const original = docStore.selectionMask()
const prevQuickMask = ui.quickMask
ui.quickMask = true
docStore.beginTransaction('history.refineEdge')
let timer: number | null = null
function preview() {
  if (timer !== null) clearTimeout(timer)
  timer = window.setTimeout(() => {
    timer = null
    if (!original) return
    docStore.setSelection(refineMask(original, { smooth: smooth.value, feather: feather.value, contrast: contrast.value, shift: shift.value }), 'history.refineEdge')
  }, 60)
}
watch([smooth, feather, contrast, shift], preview)
let done = false
function ok() {
  done = true
  if (timer !== null) clearTimeout(timer)
  docStore.rollbackTransaction()
  ui.quickMask = prevQuickMask
  void runCommand('selection.refine', { smooth: smooth.value, feather: feather.value, contrast: contrast.value, shift: shift.value })
  emit('close')
}
function cancel() {
  done = true
  if (timer !== null) clearTimeout(timer)
  docStore.rollbackTransaction()
  ui.quickMask = prevQuickMask
  emit('close')
}
onBeforeUnmount(() => {
  if (!done) cancel()
})
</script>

<template>
  <div class="modal-backdrop" @pointerdown.self="cancel">
    <div class="modal refine" @keydown.esc="cancel" @keydown.enter="ok">
      <h2>{{ t('refine.title') }}</h2>
      <SliderField :label="t('refine.smooth')" :value="smooth" :min="0" :max="100" :step="1" unit="px" @input="v => (smooth = v)" @change="v => (smooth = v)" />
      <SliderField :label="t('refine.feather')" :value="feather" :min="0" :max="250" :step="0.5" unit="px" @input="v => (feather = v)" @change="v => (feather = v)" />
      <SliderField :label="t('refine.contrast')" :value="contrast" :min="0" :max="100" :step="1" unit="%" @input="v => (contrast = v)" @change="v => (contrast = v)" />
      <SliderField :label="t('refine.shift')" :value="shift" :min="-100" :max="100" :step="1" unit="%" @input="v => (shift = v)" @change="v => (shift = v)" />
      <div class="actions">
        <button @click="cancel">{{ t('dialog.cancel') }}</button>
        <button class="primary" @click="ok">{{ t('dialog.ok') }}</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.refine {
  min-width: 380px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>
